import React, { createContext, useContext } from 'react';
import { useLoader } from './useLoader';

const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
  const loader = useLoader();

  return (
    <LoaderContext.Provider value={loader}>{children}</LoaderContext.Provider>
  );
};

export const useLoaderContext = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoaderContext must be used within a LoaderProvider');
  }
  return context;
};
